"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(_ref) {
  var sendTypingIndicator = _ref.sendTypingIndicator;
  return sendTypingIndicator;
};

exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zZWxlY3RvcnMvc2VuZFR5cGluZ0luZGljYXRvci5qcyJdLCJuYW1lcyI6WyJzZW5kVHlwaW5nSW5kaWNhdG9yIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O2VBQWU7QUFBQSxNQUFHQSxtQkFBSCxRQUFHQSxtQkFBSDtBQUFBLFNBQTZCQSxtQkFBN0I7QUFBQSxDIiwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgKHsgc2VuZFR5cGluZ0luZGljYXRvciB9KSA9PiBzZW5kVHlwaW5nSW5kaWNhdG9yO1xuIl19